import moment from 'moment';
import modal from 'helpers/modal';
import template from '../../templates/settings/Integrations.ejs';
import IntegrationsConnectTemplate
    from '../../templates/settings/IntegrationsConnect.ejs';
import FormView from 'commons/views/Form';
import XeroPayrollItemIntegrationsView
    from './integrations/xero/PayrollItems.js';
import QuickbooksPayrollItemIntegrationsView
    from './integrations/quickbooks/PayrollItems.js';
import QuickbooksPaymentAccountIntegrationsView
    from './integrations/quickbooks/PaymentAccounts.js';
import config from 'config';

module.exports = FormView.extend({
    events: function() {
        return Object.assign({}, FormView.prototype.events() || {}, {
            'ifToggled input.js-ext-payrollSyncDate':
            'togglePayrollSyncDatepicker',
            'changeDate .js-ext-datepicker': 'updatePayrollSyncDate',
            'change .js-contact select': 'updateContact',
            'change .js-mapping-type select': 'updateMappingType',
            'click .js-connect': 'closeCurrentWindow',
            'click .js-destroy': 'renderConnectButton',
            'change .js-mapping-type': 'renderXeroMappedItems'
        });
    },

    initialize: function(options) {
        this.options = Object.assign({
            template,
            mappedItems: null,
            mappableItems: null,
            defaults: null,
            paymentAccounts: null,
            items: null
        }, options || {});

        this.options.templateExtra = {
            employeeDebit: this.options.employeeDebit,
            provider: this.options.provider,
            qbAccounts: this.options.qbAccounts,
            organisations: this.options.organisations,
            contacts: this.options.contacts,
            debitAccounts: this.options.debitAccounts,
            creditAccounts: this.options.creditAccounts,
            mappingTypes: this.options.mappingTypes
        };

        this.payrollItemIntegrationsView = null;
        this.paymentAccountIntegrationsView = null;

        if (!this.model) {
            this.renderConnectButton();
        }

        FormView.prototype.initialize.apply(this, [this.options]);

        if (this.model) {
            this.model.off('destroy');
            this.model.off('sync');
            this.model.on('destroy', this.renderConnectButton, this);
            this.model.on('saved', this.afterSave, this);
            this.checkIntegration();
        }

        return this;
    },

    checkIntegration: function() {
        if (this.options.provider === 'xero') {
            // checking currency
            const selectedOrg = this.options.organisations
                .find(org =>
                    this.model.get('organisationID') === org.organisationID
                );
            const isValidCurrency = !!selectedOrg &&
                selectedOrg.currency === 'MYR';

            if (!!selectedOrg && !isValidCurrency) {

                modal.showError(
                    'You tried to connect to a Xero organisation that ' +
                    'follows a non-MYR currency, PayrollPanda only ' +
                    'connects to organisations that follow MYR currency.',
                    false
                );
            }
        }
    },

    bindHandlers: function() {
        this.model.on(
            'change:payrollSyncDate',
            this.togglePayrollSyncButtons,
            this
        );

        return FormView.prototype.bindHandlers.apply(this, arguments);
    },

    render: function() {
        const provider = this.options.provider;

        FormView.prototype.render.apply(this, arguments);

        if (this.model) {
            if (provider === 'quickbooks') {
                this.renderQuickbooksMappedItems();
                this.renderQuickbooksPaymentAccounts();
            }

            if (provider === 'xero') {
                this.renderXeroMappedItems();
            }
        }

        this.$('.js-ext.js-ext-datepicker')
            .addClass('js-ignore')
            .datepicker({
                autoclose: true,
                format: 'dd',
                keyboardNavigation: false,
                todayBtn: 'linked',
                todayHighlight: true
            })
            .removeClass('js-ignore');

        return this;
    },

    renderQuickbooksMappedItems: function() {
        if (!this.payrollItemIntegrationsView) {
            this.payrollItemIntegrationsView =
                new QuickbooksPayrollItemIntegrationsView({
                    collection: this.options.mappedItems,
                    defaults: this.options.defaults,
                    mappableItems: this.options.mappableItems,
                    qbAccounts: this.options.qbAccounts,
                    integration: this.model
                });
        }

        this.$('.js-payroll-item-integrations').append(
            this.payrollItemIntegrationsView.$el
        );

        return this;
    },

    renderQuickbooksPaymentAccounts: function() {
        if (!this.paymentAccountIntegrationsView) {
            this.paymentAccountIntegrationsView =
                new QuickbooksPaymentAccountIntegrationsView({
                    collection: this.options.paymentAccounts,
                    qbAccounts: this.options.qbAccounts,
                    integration: this.model
                });
        }

        this.$('.js-payment-accounts-integrations').append(
            this.paymentAccountIntegrationsView.$el
        );

        return this;
    },

    renderXeroMappedItems: function() {
        const mappingType = this.model.get('mappingType');

        this.payrollItemIntegrationsView =
            new XeroPayrollItemIntegrationsView({
                collection: this.options.items,
                integration: this.model,
                mappingType: mappingType,
                mappableItems: this.options.mappableItems,
                debitAccounts: this.options.debitAccounts,
                creditAccounts: this.options.creditAccounts,
                contacts: this.options.contacts,
            });

        this.$('.js-payroll-item-integrations').html(
            this.payrollItemIntegrationsView.$el
        );

        return this;
    },

    renderConnectButton: function() {
        if (this.model) {
            this.model.destroy();
        }
        const baseUrl = `${config.apiUrl}/integrations/auth`;

        const authUrl = (provider) => `${baseUrl}/${app.company.id}/` +
            `${provider}?access_token=${app.user.getAccessToken().id}`;

        this.$el.html('').html(IntegrationsConnectTemplate({
            quickbooksAuthUrl: authUrl('quickbooks'),
            xeroAuthUrl: authUrl('xero')
        }));

        return this;
    },

    togglePayrollSyncButtons: function(model) {
        if (!model.get('payrollSyncDate')) {
            this.$('.js-ext-payrollSyncDate[value=0]:not(:checked)')
                .iCheck('check');
        } else {
            this.$('.js-ext-payrollSyncDate[value=1]:not(:checked)')
                .iCheck('check');
        }
    },

    togglePayrollSyncDatepicker: function(ev) {
        const $input = this.$(ev.currentTarget);
        const customDate = ($input.val() === '1');

        if (!$input.is(':checked')) {
            return;
        }

        this.$('.js-payrollSyncDateFormGroup').toggleClass(
            'hidden', !customDate
        );

        if (!customDate) {
            this.model.set('payrollSyncDate', null, {silent: true});
            this.renderAttribute(this.model, 'payrollSyncDate');
        }
    },

    updatePayrollSyncDate: function() {
        const $input = this.$('input[name="payrollSyncDate"]');
        const date = parseInt($input.val()) || moment().date();

        this.model.set('payrollSyncDate', date);
    },

    updateContact: function(ev) {
        const $input = this.$(ev.currentTarget);
        const id = this.getInputValue($input);

        this.model.set({contact: id});
    },

    updateMappingType: function(ev) {
        const $input = this.$(ev.currentTarget);
        const id = this.getInputValue($input);

        this.model.set({mappingType: id});
    },

    closeCurrentWindow: function() {
        setTimeout(window.close, 500);
    },

    afterSave: function() {
        modal.showAlertSuccess('Integration settings have been saved');
        if (this.options.provider === 'xero') {
            return this.model.fetchData()
                .then(({
                    organisations,
                    contacts,
                    debitAccounts,
                    creditAccounts
                }) => {
                    this.options = Object.assign(this.options, {
                        organisations,
                        contacts,
                        debitAccounts,
                        creditAccounts
                    });

                    this.renderXeroMappedItems();
                });
        }
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/Integrations.js